"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _formik = require("formik");

var yup = _interopRequireWildcard(require("yup"));

var Buttons = _interopRequireWildcard(require("../../../components/input/button/Button"));

var TextFields = _interopRequireWildcard(require("../../../components/input/textfield/TextField"));

var css = _interopRequireWildcard(require("./VerifyForm.styles"));

var _errorCopy = _interopRequireDefault(require("../errorCopy"));

var _ErrorBar = _interopRequireDefault(require("../errorBar/ErrorBar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var maskCustomerNumber = function maskCustomerNumber(customerNumber) {
  return "".concat(customerNumber.substring(0, 2), "***").concat(customerNumber.substring(customerNumber.length - 2, customerNumber.length));
};

var VerifyForm = function VerifyForm(_ref) {
  var verifyFn = _ref.verifyFn,
      backFn = _ref.backFn,
      resendFn = _ref.resendFn,
      customerNumber = _ref.customerNumber,
      _ref$retryTimeoutSeco = _ref.retryTimeoutSeconds,
      retryTimeoutSeconds = _ref$retryTimeoutSeco === void 0 ? 15 : _ref$retryTimeoutSeco,
      customError = _ref.customError;

  var _useState = (0, React.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, React.useState)(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0, React.useState)(retryTimeoutSeconds),
      _useState6 = _slicedToArray(_useState5, 2),
      retryTimeoutSecondsRemaining = _useState6[0],
      setRetryTimeoutSecondsRemaining = _useState6[1];

  var _useState7 = (0, React.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      maskedCustomerNumber = _useState8[0],
      setMaskedCustomerNumber = _useState8[1];

  var _useState9 = (0, React.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isTimerRunning = _useState10[0],
      setTimerRunning = _useState10[1];

  (0, React.useEffect)(function () {
    if (customerNumber) {
      setMaskedCustomerNumber(maskCustomerNumber(customerNumber));
    }
  }, [customerNumber]);
  (0, React.useEffect)(function () {
    if (isTimerRunning) {
      setTimeout(function () {
        if (retryTimeoutSecondsRemaining === 1) {
          setTimerRunning(false);
          setRetryTimeoutSecondsRemaining(retryTimeoutSeconds);
        } else {
          setRetryTimeoutSecondsRemaining(retryTimeoutSecondsRemaining - 1);
        }
      }, 1000);
    }
  }, [isTimerRunning, retryTimeoutSeconds, retryTimeoutSecondsRemaining]);

  var resendAction = function resendAction() {
    setTimerRunning(true);
    resendFn();
  };

  var formik = (0, _formik.useFormik)({
    initialValues: {
      verificationCode: ''
    },
    validationSchema: yup.object({
      verificationCode: yup.string().required(_errorCopy["default"].verifyRequired).test('len', _errorCopy["default"].verifyChar, function (val) {
        return val.length === 6;
      })
    }),
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!loading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                setLoading(true);
                setError(undefined);
                _context.prev = 4;
                _context.next = 7;
                return verifyFn(values.verificationCode);

              case 7:
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);
                setError(_context.t0);

              case 12:
                setLoading(false);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 9]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var handleCloseErrorBar = function handleCloseErrorBar() {
    setError(undefined);
  };

  (0, React.useEffect)(function () {
    setError(customError);
  }, [customError]);
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: (0, _jsxRuntime.jsxs)("form", {
      onSubmit: formik.handleSubmit,
      children: [maskedCustomerNumber && (0, _jsxRuntime.jsxs)("span", {
        children: ["We just sent a code to ", maskedCustomerNumber, ", please enter it below.", ' ']
      }), resendFn && (0, _jsxRuntime.jsxs)("span", {
        children: ["Didn't recieve a code?", ' ', isTimerRunning ? (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: ["Please wait ", retryTimeoutSecondsRemaining, " seconds to retry."]
        }) : (0, _jsxRuntime.jsx)(Buttons.Text, {
          onClick: resendAction,
          css: css.resendButton,
          children: "Resend Code"
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        children: (0, _jsxRuntime.jsx)(TextFields.Outlined, {
          name: "verificationCode",
          label: "Verification code",
          fullWidth: true,
          onChange: formik.handleChange,
          value: formik.values.verificationCode,
          onBlur: formik.handleBlur,
          error: formik.touched.verificationCode && Boolean(formik.errors.verificationCode),
          helperText: formik.touched.verificationCode && Boolean(formik.errors.verificationCode) ? formik.errors.verificationCode : ''
        })
      }), error && (0, _jsxRuntime.jsx)(_ErrorBar["default"], {
        error: error,
        closeFn: handleCloseErrorBar
      }), (0, _jsxRuntime.jsx)(_core.Box, {
        children: (0, _jsxRuntime.jsxs)(_core.Grid, {
          container: true,
          css: css.actions,
          children: [(0, _jsxRuntime.jsx)(Buttons.Text, {
            onClick: backFn,
            css: css.backButton,
            children: "Back"
          }), (0, _jsxRuntime.jsx)(Buttons.Primary, {
            type: "submit",
            loading: loading,
            disabled: !(formik.isValid && formik.dirty),
            children: "Verify"
          })]
        })
      })]
    })
  });
};

var _default = VerifyForm;
exports["default"] = _default;